// angular
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// material 
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table'

// models 
import { BrandSeed } from '../../shared/models/BrandSeed';

// services 
import { BrandSeedService } from '../../shared/services/brandSeed.service'; 
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationModalService } from '../../shared/components/modals/confirmation-modal/confirmation-modal.service';
import { BrandSeedFormComponent } from '../../shared/components/modals/brand-seed-modal/brand-seed-form.component';

@Component({
  selector: 'app-brand-seeds',
  templateUrl: './brand-seeds.component.html'
})

export class BrandSeedsComponent implements OnInit {
  
  // MatPaginator Inputs
  length = 20;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 100];
  pageEvent: PageEvent;
  dataSource = new MatTableDataSource<BrandSeed>();
  displayedColumns: string[] = ['actions','id', 'patientId', 'fullName', 'dateOfBirth', 'gender', 'months'];
 
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(
    private brandSeedService: BrandSeedService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private notification: MatSnackBar,
    private confirmationModalService: ConfirmationModalService
  ) { }

  private _id; // private property _item

  // use getter setter to define the property
  get id(): any {
    return this._id;
  }

  @Input()
  set id(val: any) {
    this._id = val;
  }

  ngOnInit() {
    this.getItems(this.id);
  }
   
  // gets records per brand id
  getItems(id: number): void {
    if (id > 0) { 
      this.brandSeedService.getAll(id).subscribe(result => {
          this.dataSource.data = result;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort; 
      }, error => console.error(error));
    }
  }
   
  // delete item
  deleteItem(id: number) {

    this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
      .then((confirmed) => {
        if (confirmed) {
          this.brandSeedService.delete(id).subscribe(() => {
            this.showNotification('The seed has been deleted successfully!', 'Okay!');
            this.getItems(this.id);
          });
        }
      }
      )
      .catch(() =>
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      );
  }


  // copy entry
  copyItem(item: BrandSeed): void {

    let modalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
    };

    const modalRef = this.modalService.open(BrandSeedFormComponent, modalOptions);
    modalRef.componentInstance.title = 'Copy Seed';
    modalRef.componentInstance.inputModel = item;
    modalRef.componentInstance.inputModel.id = 0; // reset unique id in order to make copy
     
    // modal result
    modalRef.result.then((result) => {
      this.getItems(this.id);
    }).catch(() =>
      console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
    );
  }

  // open add form 
  openAddModal() {
    let modalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
    };

    const modalRef = this.modalService.open(BrandSeedFormComponent, modalOptions);
    modalRef.componentInstance.title = 'Add Seed';

    let model: BrandSeed = {
      id: 0,
      patientId: '',
      clxPatientId: '',
      firstName: '',
      lastName: '',
      address1: '',
      address2: '',
      city: '',
      state: null,
      zipCode: '',
      gender: null,
      dateOfBirth: '',
      age: 0,
      lastExamDate: '',
      months: 0,
      brandId: this.id,
      campaignTypeId: 0,
      campaignTypeName: '',
      storeLocationId: 0,
      storeNumber: '',
      phone: '',
      email: '',
      custom1: '',
      custom2: '',
      custom3: '',
      custom4: '',
      custom5: ''
    };

    modalRef.componentInstance.inputModel = model;
     
    // modal result
    modalRef.result.then((result) => {
      if (result) {
        this.getItems(this.id);
      }
    }).catch(() =>
      console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
    );
  }
   
  //// edit item
  editItem(model: BrandSeed) { 
    let modalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
    };

    const modalRef = this.modalService.open(BrandSeedFormComponent, modalOptions);
    modalRef.componentInstance.title = 'Edit Record';
    modalRef.componentInstance.inputModel = model;
   
    // modal result
    modalRef.result.then((result) => {
      if (result) {
        this.getItems(this.id);
      }
    }).catch(() =>
      console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
    );
  }

  // filter locations
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // show notification popup
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
  }
}
